var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductForm',{class:!_vm.loading && 'disable-ske',attrs:{"value":_vm.initialData,"isShowing":_vm.isShowing},on:{"save":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }